import React from "react";

// Components
import ContentCard from "../../../../UI/ContentCard/ContentCard";

// Images
import trendImg from "../../../../assests/images/trendsetter.png";

const ConceptTrendsetter = () => (
  <ContentCard
    title="Become a trendsetter"
    id="Customize your clothes"
    image={trendImg}
    imageTitle="THE MODEL IN FIVE STEPS"
    frontText="At SAMPELL you can customize your clothes and resell your design"
    backTextOne="We want to provide the most possible style freedom to you, so that you can create new trends and share your unique
      fashion taste with others. We offer different pattern options, various colors as well as accessories to choose from.
      You can finish your garments with your own print design or with prints from the SAMPELL gallery. With a few klicks you create your own unique combinations."
    backTextTwo="Of course we can‘t anticipate every possible style option. If you do not find the options that you are looking for, you can describe
    your details to us. Whenever it is doable, we bring your ideas to life."
    backTextThree="It is essential for us, that everyone can realize their ideas. So you do not need to be a professional pattern maker or fashion
    designer. You just scribble your ideas with a pencil or write down your ideas."
    backTextFour="If you are a professional pattern maker, of course you also can contact us. If you have a unique pattern, but not the ressources for production, we together will find a way to introduce your design to the SAMPELL community and beyond."
  />
);

export default ConceptTrendsetter;



// WEBPACK FOOTER //
// ./src/components/Pages/Concept/Content/ConceptTrendsetter.js